<script lang="ts" setup>
import LanguageSelector from './LanguageSelector.vue'
import Logo from './Logo.vue'
</script>

<template>
    <VSystemBar
        window
        color="mainMenu"
    >
        <Logo />
        <v-spacer />
        <LanguageSelector class="support-page-toolbar__language-selector" />
    </VSystemBar>
</template>

<style>
    .support-page-toolbar {
        &__language-selector {
            margin-inline-end: 2em;

            @media (max-width: 500px) {
                margin: 0;
            }
        }
    }
</style>
